import React, { Component, createRef } from 'react';
import { Link } from 'react-router-dom';
import { osName } from 'react-device-detect';
import LoadingOverlay from 'react-loading-overlay';
import _ from 'lodash';
import { createBrowserHistory } from 'history';
import { connect } from 'react-redux';

import { alertActions, } from '../../actions';
import { commonConstant, CustomCheckbox, StickyBottom } from '../../common';
import { Modal } from '../../helpers';
import { customerService, activityService } from '../../services';
import Condition from '../condition/TermsConditions.jsx';
import HomeAlertModal from '../home/homeAlertModal/HomeAlertModal.jsx';
import { IdField } from '../home/components/index.js';
import {
  LABEL_ACCEPT_TNC,
  LABEL_ALERT_DUPLICATE_DESCRIPTION,
  LABEL_MEMBER_ALERT_DUPLICATE_CANCEL_BTN,
  LABEL_MEMBER_ALERT_DUPLICATE_OK_BTN,
  LABEL_MEMBER_ALERT_WRONG_INFO_DESCRIPTION,
  LABEL_MEMBER_ALERT_WRONG_INFO_OK_BTN,
  LABEL_MEMBER_ALERT_WRONG_INFO_TITLE,
  LABEL_REGISTRATION_ABO_SUBTITLE,
  LABEL_REGISTRATION_ABO_TITLE
} from '../../common/commonConstant.js';
import './foa.scss';

export const history = createBrowserHistory();

class Foa extends Component {
  constructor(props) {
    super(props);

    if (sessionStorage.getItem('customer') === null || sessionStorage.getItem('customer') === 'undefined') {
      window.location.replace(commonConstant.pathHome);
    }

    const customer = JSON.parse(sessionStorage.getItem('customer'));

    if (!customer.type) {
      return window.location.replace(commonConstant.pathHome);
    }

    this.state = {
      customer: customer,
      DistNum: '',
      tel: this.props.location?.state.tel || '',
      loading: false,
      error: false,
      show: false,
      accept: this.props.location?.state.accept || false,
      condition: false,
      isOpenModal: false,
      modalContent: '',
      resMemberNumber: null,
      profile: '',
      onPhoneFocus: false,
      selectedPartyId: '',
    };
  }

  checkboxRef = createRef();

  componentDidMount() {
    const { location } = this.props;
    if (!location.state || !location.state.myMember || location.state.myMember.accountMst.accountTypeCd !== 'Customer')
      return window.location.replace(commonConstant.pathHome);
    this.setState({ profile: location.state.myMember });
    this.checkboxRef.current.checked = this.state.accept;
  }

  onPaste = e => {
    e.preventDefault();
    return false;
  };

  handleChange = (e) => {
    const regex = /^[0-9\b]+$/;
    if (e.target.value === '' || e.target.value.match(regex)) {
      this.setState({ [e.target.name]: e.target.value });
    }
  }

  handleCheckBox = () => {
    this.props.history.replace({
      state: {
        ...this.props.location.state,
        accept: !this.state.accept
      }
    });
    this.setState({ accept: !this.state.accept });
  }
  handleCondition = () => this.setState({ condition: !this.state.condition })

  handleModalOk = () => {
    const { modalContent, isOpenModal } = this.state;
    this.toggleModal();
    switch (modalContent) {
      case 'duplicate':
        this.setState({ isOpenModal: !isOpenModal });
        return this.props.history.push('/changeMID', { myMember: this.props.location.state.myMember, oldLineId: this.state.oldLineId, oldMember: this.state.oldMember, partyId: this.state.selectedPartyId })
      case 'wrongPhone':
        this.props.history.replace({
          state: {
            ...this.props.location.state,
            accept: !this.state.accept
  }
        });
        this.setState({ isOpenModal: !isOpenModal, accept: false, tel: '' });
        this.checkboxRef.current.checked = false;
      default:
        break;
    }
  }

  toggleModal = (content, resMemberNumber = null) => {
    this.setState({
      isOpenModal: !this.state.isOpenModal,
      modalContent: content,
      resMemberNumber,
    });
  }

  handleModalContent = () => {
    const { modalContent, profile } = this.state;
    switch (modalContent) {
      case 'duplicate':
        return { title: `หมายเลขนี้มีการผูกกับ LINE`, detail: LABEL_ALERT_DUPLICATE_DESCRIPTION(this.state?.oldMember?.displayName), btnText: LABEL_MEMBER_ALERT_DUPLICATE_OK_BTN, cancelBtnText: LABEL_MEMBER_ALERT_DUPLICATE_CANCEL_BTN };
      case 'card':
        return { title: null, detail: '<img src="/images/id-card-hint.png" alt="" />' };
      case 'wrongPhone':
        return {
          title: LABEL_MEMBER_ALERT_WRONG_INFO_TITLE,
          detail: LABEL_MEMBER_ALERT_WRONG_INFO_DESCRIPTION,
          btnText: LABEL_MEMBER_ALERT_WRONG_INFO_OK_BTN
        }
      default:
        break;
    }
  }
  handleSubmit = async (e) => {
    window.scrollTo(0, 1);
    const { tel, profile } = this.state;
    const amwayNumber = profile.accountMst.aboNum;
    const accountType = profile.accountMst.accountSubTypeCd.toLowerCase();
    let userGender = '';
    let phoneList;
    e.preventDefault();
    this.setState({ loading: true });

    const accountProfile = _.filter(profile.partyList, function (o) {
      return o.phoneList[0] && o.phoneList[0].phoneLocalNum === tel;
    });

    if (accountProfile.length === 0) {
      this.setState({ isOpenModal: false, loading: false });
      this.toggleModal('wrongPhone');
      return;
    }

    //const accountProfile = _.filter(profile.partyList, function (o) { return o.taxList[0] && o.taxList[0].taxId.substr(-4) === cid; });
    const profileSchema = {
      familyName: '',
      givenName: '',
      middleName: '',
      suffix: '',
      title: '',
    };

    if (accountProfile.length > 0) {
      const localNameObj = accountProfile[0].nameList[0].localeName;
      profileSchema.familyName = (localNameObj.familyName !== null) ? localNameObj.familyName : '';
      profileSchema.givenName = (localNameObj.givenName !== null) ? localNameObj.givenName : '';
      profileSchema.middleName = (localNameObj.middleName !== null) ? localNameObj.middleName : '';
      profileSchema.suffix = (localNameObj.suffix !== null) ? localNameObj.suffix : '';
      profileSchema.title = (localNameObj.title !== null) ? localNameObj.title : '';
      userGender = accountProfile[0].partyMst.genderCd || '';
    }

    const AboName = `${profileSchema.givenName} ${profileSchema.familyName}`;

    let findIndex = profile.partyList.findIndex(party => {
      return party.phoneList[0] && party.phoneList[0].phoneLocalNum === tel;
    });

    let partyId = profile.partyList[findIndex].partyMst.partyId;
    this.setState({ selectedPartyId: partyId });

    const { location } = this.props;
    if (location?.state?.myMember && findIndex !== -1) {
      phoneList = location?.state?.myMember?.partyList?.length && location?.state?.myMember?.partyList[findIndex].phoneList?.length
        && location?.state?.myMember?.partyList[findIndex].phoneList.find((list) => list?.phoneLocalNum?.trim() !== '' && list?.contactPointTypeCd === 'Mobile' && Array.isArray(list?.usageList) && list?.usageList.find((usage) => usage?.primaryFlag));
    }

    const resMemberNumber = await customerService.findMemberByPartyId(amwayNumber, partyId);
    if (resMemberNumber && (resMemberNumber.uid !== this.state.customer.uid)) {
      if (!phoneList) {
        this.setState({ isOpenModal: false, loading: false });
        this.toggleModal('phoneNotFound');
        return;
      }
      this.setState({ isOpenModal: false, loading: false, oldLineId: resMemberNumber.uid, oldMember: resMemberNumber });
      this.toggleModal('duplicate', resMemberNumber);
      return;
    }

    const customer = {
      ...this.state.customer,
      name: AboName,
      _id: this.state.customer._id,
      info: osName === 'IOS' ? 'iPhone' : osName,
      amwayNumber: parseInt(amwayNumber),
      partyId: profile.accountMst.primaryPersonPartyId,
      gender: userGender.toLowerCase(),
      socialType: 'LINE',
      ...(phoneList ? { phone: phoneList.phoneLocalNum } : null)
    };
    sessionStorage.setItem('customer', JSON.stringify(customer));

    //------- End ABO Verify --------------------------------------------------------------

    if (!phoneList) {
      this.setState({ isOpenModal: false, loading: false });
      this.toggleModal('phoneNotFound');
      return;
    }

    return this.props.history.push(commonConstant.pathVerifyOtp, {
      myMember: this.props.location.state.myMember,
      user: customer,
      phoneList,
      detailType: accountType === 'employee' ? 'employee' : 'foa'
    });
  };

  render() {
    const { tel, isOpenModal, accept, condition, modalContent, profile } = this.state;
    const { location } = this.props;
    let lblHead = "หมายเลขสมาชิกแอมเวย์FOA";
    if (profile && profile.accountMst.aboNum) {
      if ((profile.accountMst.aboNum).substring(0, 3) == '999') {
        lblHead = "รหัสพนักงาน";
      }
    }
    const isTrue = tel.length === 10 && accept;
    const content = this.handleModalContent();
    if (condition) { return <Condition fn={this.handleCondition} />; }
    return (
      <div className='foa'>
        <LoadingOverlay active={this.state.loading} spinner text="Loading" styles={{ wrapper: { width: '100%', minHeight: '100%' } }} />
        {
          isOpenModal &&
          <HomeAlertModal
              title={content.title}
            description={content.detail}
            btnFn={this.handleModalOk}
            cancelBtnFn={this.toggleModal}
            isOpen={isOpenModal}
            onClose={this.toggleModal}
            cancelBtnText={content.cancelBtnText}
            btnText={content.btnText}
          />
        }
        <form className="registration-form" onSubmit={this.handleSubmit}>
          <div className="logoAmway">
            <img src="/images/registration/AmwayLineBusinessConnectLogo.png" alt="" />
          </div>
          <div className="title">{LABEL_REGISTRATION_ABO_TITLE}</div>
          <div className="subtitle">{LABEL_REGISTRATION_ABO_SUBTITLE}</div>
          <div className="amwayNumber">{profile && profile.accountMst.aboNum}</div>
          <div className="cid-form">
            <IdField heading="เบอร์โทรศัพท์"
              preIconPath='/images/common/PhoneIcon.svg'
              preIconDisabledPath='/images/common/PhoneIconDisabled.svg'
                  value={tel}
                  pattern="[0-9]*"
                  maxLength="10"
                  minLength="10"
                  onChange={this.handleChange}
                  name="tel"
              type="tel"
                  required
                  phone="true"
                  autoComplete="false"
                  className="center"
                  onPaste={this.onPaste}
              placeholder="ระบุเบอร์โทรศัพท์" />
              </div>
          <div className="foa-text-notice">ข้อมูลส่วนตัวของท่านจะได้รับการปกป้องอย่างปลอดภัย</div>
          <StickyBottom buttonProps={{ type: 'submit' }} buttonText="ถัดไป" isActive={isTrue}>
            <div className="home-registration-tnc-wrapper">
              <CustomCheckbox onChange={this.handleCheckBox} accept={accept} ref={this.checkboxRef} />
              <div className="home-registration-tnc-link">
                <Link className="forget-password" to={{
                  pathname: '/condition',
                  state: { from: location, tel, accept },
                }}>{LABEL_ACCEPT_TNC}</Link>
            </div>
          </div>
          </StickyBottom>
        </form>
      </div>
    );
  }
}

function mapDispatchToProps(dispatch) {
  return {
    showError: (message) => dispatch(alertActions.showError(message)),
  };
}

export default connect(null, mapDispatchToProps)(Foa);
